import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/connexion", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "admin" ? "/admin" : "/compte", { replace: true });
      } catch (e) {
        setError("La connexion Google a échoué. Veuillez réessayer.");
      }
    })();
  }, [location.hash, navigate, exchangeGoogleSession]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-sm font-semibold text-rose-600">{error}</p>
          <button
            onClick={() => navigate("/connexion")}
            className="mt-4 rounded-full bg-brand px-6 py-3 text-sm font-bold text-white"
          >
            Retour à la connexion
          </button>
        </div>
      ) : (
        <Loader2 className="h-8 w-8 animate-spin text-brand" />
      )}
    </div>
  );
}
